var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame248(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 103,
    viewBox: "0 0 102 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.6772 70.6241H74.569C76.4069 70.6241 77.8944 68.447 77.8944 65.757V17.2704H31.3518V65.757C31.3518 68.447 32.8393 70.6241 34.6772 70.6241Z",
    fill: "#FDE119"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.5299 77.6651L76.1184 67.5321C77.9424 67.0653 78.8787 64.5783 78.2117 61.9724L66.1888 15L20 26.8224L32.023 73.7947C32.69 76.4007 34.706 78.132 36.5299 77.6651Z",
    fill: "#9746FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M82.719 57.2014V82.743C82.719 85.091 80.8101 87 78.4621 87H27.3788C25.0308 87 23.1218 85.091 23.1218 82.743V48.4747C23.1218 46.1267 25.0308 44.2177 27.3788 44.2177H50.2665C51.8961 44.2177 53.3794 45.1423 54.0911 46.6056L57.184 52.9444H78.4621C80.8101 52.9444 82.719 54.8534 82.719 57.2014Z",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M65.6913 57.0018C65.6913 55.625 65.5981 54.2681 65.4186 52.9444H57.184L54.0911 46.6056C53.3794 45.1423 51.8895 44.2177 50.2665 44.2177H27.3788C25.0308 44.2177 23.1218 46.1267 23.1218 48.4747V82.743C23.1218 83.1887 23.1883 83.621 23.3214 84.0268C27.1393 85.8027 31.4029 86.8004 35.8927 86.8004C52.3484 86.8004 65.6913 73.4576 65.6913 57.0018Z",
    fill: "#67E8F9",
    fillOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame248);
export default __webpack_public_path__ + "static/media/Frame 248.19095e01e18ab2b6061235e60d238db0.svg";
export { ForwardRef as ReactComponent };